import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCircleExclamation, faFileCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { hooks as commonHooks } from '@sitebuilder/common';
import { types as coreTypes } from '@sitebuilder/core';
import {
    chevronDownDarkSvg,
    folderCircleCheckPng,
    folderCircleExclaimationJpg,
} from '../../assets/images';

import AuthorEmail from '../BaseComponents/AuthorEmail';
import { EnvSync } from '../../types';

interface DiffItemProps {
    item: coreTypes.EnvDiff & {
        children?: any;
        folderPath?: string;
    };
    isNestedNode?: boolean;
    selectedItems: EnvSync[];
    activeFolders: string[];
    onClickFolder: (path: string) => void;
    onSelectItem: (data: EnvSync) => void;
}

const DiffItem = (props: DiffItemProps) => {
    const { item, isNestedNode, onSelectItem, selectedItems, onClickFolder, activeFolders } = props;
    const i18n = commonHooks.useLocalization();

    let diffMsg = '';

    if (!item?.src) {
        diffMsg = 'Right only';
    } else if (!item?.dest) {
        diffMsg = 'Left only';
    } else if (item.isDifferent && (item.isFolder || item?.children)) {
        diffMsg = 'Folders are different';
    } else if (item.isDifferent && !item.isFolder) {
        diffMsg = 'Files are different';
    }

    return (
        <>
            <tr>
                <td
                    className="file-name-cell"
                    style={{
                        paddingLeft: `${(item?.folderPath?.split('/')?.length || 0) - 1}rem`,
                    }}
                >
                    <div className={`file-name ${isNestedNode ? 'nested-node' : ''}`}>
                        <div className="accordion-icon-container">
                            {item?.children && (
                                <img
                                    id="accordion-icon"
                                    className={`accordion-icon ${
                                        !activeFolders.includes(item?.folderPath || '')
                                            ? 'closed-icon'
                                            : ''
                                    }`}
                                    src={chevronDownDarkSvg}
                                    alt="accordion-icon"
                                    onClick={() => onClickFolder(item.folderPath || '')}
                                />
                            )}
                        </div>
                        <span className="diff-icon">
                            {item.isFolder || item?.children ? (
                                <>
                                    {item.isDifferent ? (
                                        <img
                                            id="folder-different-icon"
                                            className={'folder-icon folder-different-icon'}
                                            src={folderCircleExclaimationJpg}
                                            alt="folder-different-icon"
                                        />
                                    ) : (
                                        <img
                                            id="folder-similar-icon"
                                            className={'folder-icon folder-similar-icon'}
                                            src={folderCircleCheckPng}
                                            alt="folder-similar-icon"
                                        />
                                    )}
                                </>
                            ) : (
                                (!item?.children || item?.children?.length === 0) && (
                                    <>
                                        {item.isDifferent ? (
                                            <>
                                                <input
                                                    className="diff-item-select"
                                                    type="checkbox"
                                                    checked={
                                                        item.folderPath
                                                            ? selectedItems.findIndex(
                                                                  (obj: EnvSync) =>
                                                                      obj.key === item.folderPath
                                                              ) >= 0
                                                            : false
                                                    }
                                                    aria-label={i18n.t('select_user')}
                                                    onChange={() =>
                                                        item.folderPath &&
                                                        onSelectItem({
                                                            key: item.folderPath,
                                                            srcVersion: item?.src?.versionNumber,
                                                            destVersion: item?.dest?.versionNumber,
                                                            msg: diffMsg,
                                                        })
                                                    }
                                                />
                                                <FontAwesomeIcon
                                                    className={'file-icon-different'}
                                                    icon={faFileCircleExclamation}
                                                />
                                            </>
                                        ) : (
                                            <FontAwesomeIcon
                                                className={'file-icon-similar'}
                                                icon={faFileCircleCheck}
                                            />
                                        )}
                                    </>
                                )
                            )}
                        </span>
                        <span>{item.key}</span>
                    </div>
                </td>
                <td>{item?.folderPath}</td>
                <td>{diffMsg}</td>
                <td>
                    <AuthorEmail authorId={item?.src?.author} />
                </td>
                <td>
                    <AuthorEmail authorId={item?.dest?.author} />
                </td>
                <td>
                    {i18n.t(new Date(item?.src?.lastModifiedDate).toUTCString(), 'dateShort') || ''}
                </td>
                <td>
                    {i18n.t(new Date(item?.dest?.lastModifiedDate).toUTCString(), 'dateShort') ||
                        ''}
                </td>
            </tr>
            {activeFolders.includes(item?.folderPath || '') && item?.children ? (
                <>
                    {item?.children?.map((item: any) => (
                        <DiffItem
                            key={item.key}
                            item={item}
                            isNestedNode={true}
                            selectedItems={props.selectedItems}
                            activeFolders={props.activeFolders}
                            onClickFolder={(path) => props.onClickFolder(path)}
                            onSelectItem={(data) => props.onSelectItem(data)}
                        />
                    ))}
                </>
            ) : null}
        </>
    );
};

export default DiffItem;
